/*
*  Modal responsible for Re-activating an inactive Site Admin
*
* Copyright (C) 2018, 2019, 2020 Sterilis Solutions LLC all rights reserved.
*/
import React from 'react';
import { withTranslation as translate} from "react-i18next";
import SimpleLoader from "./SimpleLoader";
import {Button, Header, Modal, TransitionablePortal} from "semantic-ui-react";
import AuthService from "./AuthService";
import * as Sentry from "@sentry/browser";
import {prettyGroupName} from "./library/helpers";
import get from "lodash/get";

const Auth = new AuthService();

class ReactivateSiteAdminModal extends React.Component {
  state = {
    allowModalToBeClosed: true,
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.setState({
      siteAdminBeingReactivated: this.props.siteAdminBeingReactivated,
      groupName : prettyGroupName(get(this.props.siteAdminBeingReactivated, 'groups[0].name', 'Portal User')),
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({width: window.innerWidth, height: window.innerHeight});
  };

  reactivateSiteAdmin = () => {
    const {siteAdminBeingReactivated} = this.state;
    const siteAdminBeingReactivatedEmployeeID = siteAdminBeingReactivated.employee.id;
    const siteAdminBeingReactivatedUsername = siteAdminBeingReactivated.username;

    this.setState({
      appLoading: true,
      allowModalToBeClosed: false
    });

    Auth.fetch(`/api/employee/`+siteAdminBeingReactivatedEmployeeID+'/', {
      method: 'DELETE',
    }).then(data => {
      this.setState({
        appLoading: false,
        allowModalToBeClosed: true
      });

      this.props.handleReactivateSiteAdminModal();
      this.props.fetchSiteAdmins();
      if (this.props.allUsers === false) {
        this.props.fetchDeviceOperators();
      }
      // this.props.notifySiteAdminReactivationSuccess(siteAdminBeingReactivatedUsername);
      this.props.notifyGenericSuccess("re-activated", "site admin", siteAdminBeingReactivatedUsername);
    }).catch(e => {
      Sentry.captureException(e);
      // this.props.notifySiteAdminReactivationFailure(siteAdminBeingReactivatedUsername);
      this.props.notifyGenericFailure("re-activate", "site admin", siteAdminBeingReactivatedUsername);
      this.setState({
        appLoading: false,
        allowModalToBeClosed: true
      });
    });
  };

  render() {
    // const topMargin = this.state.height < 1000 ? '3vh' : '10vh';
    const inlineStyle = {
      modal: {
        // marginTop: topMargin,
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '600px',
      },
      textArea: {
        marginTop: '50px',
        width: '400px'
      }
    };
    const {
      appLoading
    } = this.state;

    const {
      t,
      siteAdminBeingReactivated
    } = this.props;

    const siteAdminUsername = siteAdminBeingReactivated.username;

    return (
      <TransitionablePortal
        open={this.props.showReactivateSiteAdminModal}
        onOpen={() => setTimeout(() => document.body.classList.add('modal-fade-in'), 0)}
        transition={{animation: 'scale', duration: 500}}
      >
        <Modal
          style={inlineStyle.modal}
          open={true}
          closeOnDimmerClick={this.state.allowModalToBeClosed}
          closeIcon={<Button className='close-modal-btn grey-btn'>{t('Close')}</Button>}
          onClose={(event) => {
            document.body.classList.remove('modal-fade-in');
            this.props.handleReactivateSiteAdminModal(this.props.siteAdminBeingReactivated)
          }}
        >
          {appLoading ? (
            <SimpleLoader/>
          ) : null}
          <Header>
            <h2 className='light-green'>{t('Reactivate')} {this.state.groupName}</h2>
          </Header>
          <Modal.Content className='create-device-operator-cust'>
            <div className='short-modal-text center-text'>
              {t('Are you sure you want to activate')} {siteAdminUsername}'s {this.state.groupName} {t('account')}?
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button className='green-btn'
                    value="Submit"
                    type="submit"
                    id='reactivateSiteAdmin'
                    onClick={this.reactivateSiteAdmin}
            >{t('Reactivate')} {this.state.groupName}</Button>
          </Modal.Actions>
        </Modal>
      </TransitionablePortal>
    )
  }
}

export default translate('translations')(ReactivateSiteAdminModal);
 